import React from 'react'
import { Create } from 'react-admin'
import UpsellingFacetSection from 'ui-shared/Facets/FacetFormSections/UpsellingFacetSection'
import UpsellingForm from 'ui-shared/Forms/UpsellingForm'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const PhysicalExperienceUpsellingCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <UpsellingForm
          relatedProduct="physicals"
          facetFields={<UpsellingFacetSection />}
        />
      </Create>
    </SectionWrapper>
  )
}

export default PhysicalExperienceUpsellingCreate
